import {getObjectById} from "../../utils/common";
import {act} from "react-dom/test-utils";
import * as _ from "lodash";

export const SET_SIDEBAR_SHADOW = 'THEME_OPTIONS/SET_SIDEBAR_SHADOW',
    SET_SIDEBAR_TOGGLE_MOBILE = 'THEME_OPTIONS/SET_SIDEBAR_TOGGLE_MOBILE',
    SET_SIDEBAR_FIXED = 'THEME_OPTIONS/SET_SIDEBAR_FIXED',
    SET_SIDEBAR_FOOTER = 'THEME_OPTIONS/SET_SIDEBAR_FOOTER',
    SET_SIDEBAR_TOGGLE = 'THEME_OPTIONS/SET_SIDEBAR_TOGGLE',
    SET_SIDEBAR_USERBOX = 'THEME_OPTIONS/SET_SIDEBAR_USERBOX',
    SET_SIDEBAR_HOVER = 'THEME_OPTIONS/SET_SIDEBAR_HOVER',
    SET_ACTIVE_LINK = 'THEME_OPTIONS/SET_ACTIVE_LINK',
    AVATAR_LOADING = 'AVATAR_LOADING',
    USER_UPDATED = 'USER_UPDATED',
    TOGGLE_USER_EDIT = 'TOGGLE_USER_EDIT',
    TOGGLE_EDIT_PASSWORD = 'TOGGLE_EDIT_PASSWORD',
    TOGGLE_PAYMENT_EDIT = 'TOGGLE_PAYMENT_EDIT',
    CLOSE_EDIT_PASSWORD = 'CLOSE_EDIT_PASSWORD',
    EDIT_CASE = 'EDIT_CASE',
    UNSUBSCRIBE = 'UNSUBSCRIBE',
    SET_BOX_PARAMS = 'SET_BOX_PARAMS',
    TOGGLE_BOX = 'TOGGLE_BOX';

interface Layout {
    activeLink: any,
    editUser: boolean
    editPassword: boolean,
    editPayment: boolean,
    editCase: boolean,
    unsubscribed: boolean | undefined,
    userUpdated: boolean,
    descriptionBoxParams: Array<{
        id: string,
        isLong: boolean,
        txtLength: number,
    }>,
}

const initialState: Layout = {
    activeLink: '/dashboard',
    editUser: false,
    editPassword: false,
    editCase: false,
    editPayment: false,
    unsubscribed: undefined,
    userUpdated: false,
    descriptionBoxParams: []
};

const Layout = (state = initialState, action: any) => {
    switch (action.type) {
        // Sidebar

        case SET_SIDEBAR_SHADOW:
            return {
                ...state,
                sidebarShadow: action.sidebarShadow
            };
        case SET_SIDEBAR_FIXED:
            return {
                ...state,
                sidebarFixed: action.sidebarFixed
            };
        case SET_SIDEBAR_TOGGLE_MOBILE:
            return {
                ...state,
                sidebarToggleMobile: action.sidebarToggleMobile
            };
        case SET_SIDEBAR_FOOTER:
            return {
                ...state,
                sidebarFooter: action.sidebarFooter
            };
        case SET_SIDEBAR_TOGGLE:
            return {
                ...state,
                sidebarToggle: action.sidebarToggle
            };
        case SET_SIDEBAR_HOVER:
            return {
                ...state,
                sidebarHover: action.sidebarHover
            };
        case SET_SIDEBAR_USERBOX:
            return {
                ...state,
                sidebarUserbox: action.sidebarUserbox
            };
        case AVATAR_LOADING:
            return {
                ...state,
                avatarLoading: action.payload
            };
        case SET_ACTIVE_LINK:
            return {
                ...state,
                activeLink: action.activeLink
            };
        case TOGGLE_USER_EDIT:
            return {
                ...state,
                editUser: !state.editUser
            };
        case TOGGLE_PAYMENT_EDIT:
            return {
                ...state,
                editPayment: !state.editPayment
            };
        case TOGGLE_EDIT_PASSWORD:
            return {
                ...state,
                editPassword: !state.editPassword
            };
        case CLOSE_EDIT_PASSWORD:
            return {
                ...state,
                editPassword: false
            };
        case EDIT_CASE:
            return {
                ...state,
                editCase: action.action
            };
        case UNSUBSCRIBE:
            return {
                ...state,
                unsubscribed: action.action
            };
        case USER_UPDATED:
            return {
                ...state,
                userUpdated: action.payload
            };
        case SET_BOX_PARAMS:
            const newState = {...state};
            newState.descriptionBoxParams.push(action.data);
            return newState;
        case TOGGLE_BOX:
            console.log(action.data)
            const newState1 = _.cloneDeep(state);
            newState1.descriptionBoxParams.forEach(el => {
                if(el.id === action.data && el.isLong) {
                    el.isLong = false;
                } else if(el.txtLength > 333 && !el.isLong) {
                    el.isLong = true;
                }
            });

            return newState1;
        default:
            break;
    }
    return state;
};

export default Layout;
